<template>
<section class="dealer_select">
    <div class="wrap" style="border: none; padding-top: 0;">
        <ul class="menu_ul notice_list" v-if="$store.state.common.onload">
            <li v-for="(noticeItem) in noticeItems" 
                :key="`${noticeItem.id}`">
                <router-link :to="`/noticeInfo/${noticeItem.id}`">
                    <dl>
                        <dt>{{noticeItem.title}}</dt>
                        <dd>{{noticeItem.startDt}}</dd>
                    </dl>
                </router-link>
            </li>
        </ul>
    </div>
</section>
</template>

<script>
import { mapState } from 'vuex';
import { DateFormatMixin } from '../../mixins/DateFormatMixin';

export default {
    name:'NoticeList',
    mixins:[DateFormatMixin],
    computed: {
        ...mapState({
            noticeItems : state => state.board.items,
            CUSTOMER_NOTICE_DTYPE: state => state.codeDictionary.items.BOARD_DTYPE.CUSTOMER_NOTICE.id
        }),
    },
    created () {
        this.$store.state.headerTitle = '공지사항';
        this.getItems();
    },
    data() {
        return {
            filters: {...this.$store.state.board.filters},
        }
    },
    methods: {
        getItems(){
            let today = this.dayjsFormat(this.getToday() , 'YYYY-MM-DD');
            this.$store.dispatch("GET_BOARD_LIST", { 
                type: this.CUSTOMER_NOTICE_DTYPE, 
                showDt: today
            })
            .then(()=>{
                this.$store.commit('SHOW_ONLOAD');
            })
            .catch((e)=> {
                this.apiCatch(e);
                this.$store.commit('SHOW_ONLOAD');
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>